import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import { MODULE_NAME } from '@modules/individuals';
import { FormControl } from "@common/components/form-control";

import Tree from '@common/components/Tree';

import "./pedigree-folder.styles.scss";

export const PedigreeFolder = (props) => {
  const { name, folderId, onChange } = props;
  const localModuleName = 'PedigreeFolderSetUp';
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    props.getData().then(setData);
  }, []);

  const handleBlur = React.useCallback((e) => {
    onChange({ name: e.target.value.trim(), folderId });
  }, [onChange, folderId]);

  const handleFolderChange = React.useCallback((selectedFolderId) => {
    onChange({ name, folderId: selectedFolderId });
  }, [onChange, name]);

  return (
    <div className="IndividualsPedigreeFolders">
      <h6 className="IndividualsPedigreeFolders__title">{I18n.t('individualMovePedigreeMsg')}</h6> 
      <h6 className="IndividualsPedigreeFolders__title">{I18n.t("What is the name of the new pedigree?")}</h6>
      <Flex justify="center" width="100%">
        <FormControl
          defaultValue={name}
          type="text"
          onBlur={handleBlur}
          {...getTestAttributes({ id: 'tx-bwstep-moveind-ped-name' })}
        />
      </Flex>
      <h6 className="IndividualsPedigreeFolders__title">{I18n.t("Select a folder")}</h6>
      <Tree
        getId={{
          folder: ({ parentIndex, ownIndex, data }) => parentIndex === undefined 
            ? `bwstep-moveind-folder-tree-content-${ownIndex}` 
            : `bwstep-moveind-folder-tree-content-child-${data.id}`,
          collapseIcon: ({ parentIndex, ownIndex, data }) => parentIndex === undefined 
            ? `bwstep-moveind-folder-tree-image-${ownIndex}` 
            : `bwstep-moveind-folder-tree-image-child-${data.id}`,
        }}
        collapseAfterLevel={0}
        className="IndividualsPedigreeFolders__list"
        items={data}
        value={folderId}
        onChange={handleFolderChange} 
      />
    </div>
  );
};
